module.exports = __webpack_public_path__ + "img/mile1-m@1.9a302350.jpg";